<!-- Fondo oscuro (solo detrás del modal) -->
<div class="modal-backdrop fade show" *ngIf="isVisible"></div>

<!-- Contenedor del modal -->
<div class="custom-modal d-block" tabindex="-1" role="dialog" *ngIf="isVisible">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()" >
        <div class="modal-content shadow-lg border-0 rounded">
            
            <div class="modal-header">
                <div (click)="close()"
                    class="close-btn-modal" >
                </div>
                <img src="assets/icons/bds_ic_information.png" alt="Información" />
            </div>

            <div class="modal-body">
                <h5 class="modal-title">{{ title }}</h5>
                <p [innerHTML]="message"></p>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="buttonText === 'Llamar' ? llamar() : close()">
                    {{ buttonText }}
                </button>
            </div>
        </div>
    </div>
</div>